import styled, { css } from "styled-components/macro";

export default styled.div`
  background-color: ${({ theme }) => theme.color.background.light};
  color: ${({ theme }) => theme.color.neutral["02"]};
  ${({ theme }) =>
    css({
      "*:before, *:after": {
        boxSizing: "inherit",
      },
      strong: {
        fontWeight: "700",
      },
      main: {
        flex: "1 0 auto",
        overflow: "hidden",
        section: {
          "&:not(.Section__Background)": {
            background: theme.color.neutral["08"],
          },
          boxShadow: theme.shadow.level["01"],
          marginBottom: "20px",
        },
      },
    })}
`;
